export default __webpack_public_path__ + "a4120f18d4e784843052ed401d6aec08.png";